export const SmsCommands = {
  GET_QUOTES: 'GET QUOTES',
  MUTE_QUOTES: 'MUTE QUOTES',
} as const;

export type SmsCommandType = (typeof SmsCommands)[keyof typeof SmsCommands];
